import type { HelpFile } from '../../types/help'
import { ErrorLogDetailTestIds } from '../../../testids/ErrorLogDetailTestIds'

export const errorLogDetailHelp: HelpFile = {
  docPage: '/docs/admin/error-log',
  texts: {
    [ErrorLogDetailTestIds.errorLogDetailPage]: 'Details for a single error — who triggered it, when, with which request, and the full stack trace.',
    [ErrorLogDetailTestIds.patternDetailPage]: 'All occurrences of the same error pattern grouped — shows frequency and affected users. Free-text search matches the message only (minimum 3 characters).',
    [ErrorLogDetailTestIds.patternInfo]: null,
    [ErrorLogDetailTestIds.patternStacktrace]: 'Stack trace shared by every occurrence of this pattern.',
    [ErrorLogDetailTestIds.cardTitleStackTrace]: null,
    [ErrorLogDetailTestIds.stacktracePre]: 'Full stack trace — copy this when filing a bug or sharing with engineering.',
    [ErrorLogDetailTestIds.cardTitleRequestContext]: null,
    [ErrorLogDetailTestIds.requestContextCard]: 'Request that triggered the error — HTTP method, path, and headers as captured at the time.',
    [ErrorLogDetailTestIds.requestSourceBadge]: 'Origin of the request: browser session, background job, or API client.',
    [ErrorLogDetailTestIds.btnToggleHeaders]: null,
    [ErrorLogDetailTestIds.headersContent]: 'Headers as the server received them — sensitive values (Authorization, cookies) are redacted.',
    [ErrorLogDetailTestIds.cardTitleOccurrenceContext]: null,
    [ErrorLogDetailTestIds.occurrenceContext]: 'Context for this occurrence — who was logged in, which session, and whether it came from a test run.',
    [ErrorLogDetailTestIds.authUsernameValue]: 'Authenticated user when the error fired — empty for anonymous requests.',
    [ErrorLogDetailTestIds.actionIdValue]: 'Internal action ID — useful when correlating with audit log entries.',
    [ErrorLogDetailTestIds.sessionIdValue]: null,
    [ErrorLogDetailTestIds.sessionIdLink]: 'Open this session in the request inspector to see all spans around the error.',
    [ErrorLogDetailTestIds.userAgentValue]: null,
    [ErrorLogDetailTestIds.e2eRunIdValue]: 'E2E test run identifier — present only when the error came from an automated Playwright run.',
    [ErrorLogDetailTestIds.e2eTestClassValue]: null,
    [ErrorLogDetailTestIds.e2eTestMethodValue]: null,
    [ErrorLogDetailTestIds.cardTitleOccurrences]: null,
    [ErrorLogDetailTestIds.occurrencesCard]: 'Every individual occurrence of this error pattern, newest first.',
    [ErrorLogDetailTestIds.occurrencesTable]: null,
    [ErrorLogDetailTestIds.colTime]: null,
    [ErrorLogDetailTestIds.colContext]: 'Request or job context for this occurrence.',
    [ErrorLogDetailTestIds.colSourceEntity]: 'Entity (party, system, request) the failing operation was acting on.',
    [ErrorLogDetailTestIds.btnCopyCorrelationId]: 'Copy the correlation ID for use in a bug report or chat.',
    [ErrorLogDetailTestIds.btnCopyTrace]: null,
  },
}
